define('view/module/cart/CartIconView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    return LayoutView.extend({

        template: '#cart_module_icon_view',

        ui: {
            'qty': '.sb-qty',
        },

        triggers: {
            'click': 'toggle:popup'
        },
    
        modelEvents: {
            'sync': 'updateState',
            'change': 'updateState',
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.call(this), {
                qty: this.model.getQty(),
            });
        },

        // update elements manually to prevent rerender of regions
        updateState: function () {
            this.ui.qty.text(this.model.getQty());
        }

    });

});
